import React from 'react';
import { Target, Users, Award, Zap } from 'lucide-react';
import { story } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const About = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation();
  const [valuesRef, valuesVisible] = useScrollAnimation();
  const values = [
    {
      icon: Target,
      title: "Mission-Driven",
      description: "Every project is guided by a clear mission to deliver exceptional value."
    },
    {
      icon: Users,
      title: "Collaborative",
      description: "We work closely with clients to ensure their vision comes to life."
    },
    {
      icon: Award,
      title: "Quality First",
      description: "Excellence is not an option, it's our standard in everything we create."
    },
    {
      icon: Zap,
      title: "Innovation",
      description: "We stay ahead of the curve with cutting-edge technology and creative solutions."
    }
  ];

  return (
    <section id="about" className="section-large bg-dark">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div ref={headerRef} className={`text-center mb-16 scroll-animate ${headerVisible ? 'visible' : ''}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {story.title}
          </h2>
          <div className="w-20 h-1 bg-accent-teal mx-auto"></div>
        </div>

        {/* Story Content */}
        <div ref={contentRef} className={`max-w-4xl mx-auto mb-20 scroll-animate-fade ${contentVisible ? 'visible' : ''}`}>
          <p className="text-lg md:text-xl text-neutral-silver leading-relaxed text-center">
            {story.content}
          </p>
        </div>

        {/* Values Grid */}
        <div ref={valuesRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div
                key={index}
                className={`text-center p-6 rounded-xl bg-accent-violet/5 border border-accent-violet/20 hover:border-accent-violet transition-all duration-300 card-hover scroll-animate-scale ${valuesVisible ? 'visible' : ''}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-violet/10 mb-4">
                  <IconComponent size={32} className="text-accent-violet" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{value.title}</h3>
                <p className="text-neutral-silver">{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
